import axios from "axios";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllStats = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(`${baseUrl}/api/dashboard/stats`, config);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getRecentMessages = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(
      `${baseUrl}/api/dashboard/recent-messages`,
      config
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
